export default "__VITE_ASSET__aac51fd0__"